import { useEffect, useState } from "react";
import { loadedEntryScript, newVersionDeployed } from "@/app/version/deployed-version";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { Button } from "@/shared/ui/primitives/Button";

export function NewVersionBar({ enabled }: { enabled: boolean }) {
  const { t } = useTranslation();
  const deployed = useNewVersion(enabled);
  if (!deployed) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[210] flex justify-center px-[16px]">
      <div
        role="status"
        className="pointer-events-auto mt-[8px] flex items-center gap-[12px] rounded-[10px] border border-(--line) bg-(--paper) py-[6px] pr-[6px] pl-[14px] text-sm text-(--ink) shadow-[var(--shadow-soft)]"
      >
        <span>{t("newVersion.text")}</span>
        <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
          {t("newVersion.reload")}
        </Button>
      </div>
    </div>
  );
}

function useNewVersion(enabled: boolean): boolean {
  const [deployed, setDeployed] = useState(false);
  useEffect(() => {
    if (!enabled || deployed) return;
    const loaded = loadedEntryScript();
    if (loaded === null) return;
    let live = true;
    const check = () => {
      void newVersionDeployed(loaded).then((found) => {
        if (live && found) setDeployed(true);
      });
    };
    const checkWhileVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    const timer = window.setInterval(checkWhileVisible, CHECK_EVERY_MS);
    document.addEventListener("visibilitychange", checkWhileVisible);
    return () => {
      live = false;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", checkWhileVisible);
    };
  }, [enabled, deployed]);
  return deployed;
}

const CHECK_EVERY_MS = 120_000;
